import React from 'react';
import PropTypes from 'prop-types';

import { prop } from '../../../common/utils/immutableHelper';

import PillsPanel from '../pillsPanel/PillsPanel';

const CommentReactions = ({ _id, content, ...rest }) => (
    <PillsPanel {...rest} elementId={_id} reactions={prop('reactions', content)} />
);

CommentReactions.propTypes = {
    _id: PropTypes.string,
    content: PropTypes.object,
};

export default CommentReactions;
